/* eslint no-undef: 0 */
import React from 'react'
import { observer } from 'mobx-react'
import { Navbar, Nav, NavDropdown, MenuItem } from 'react-bootstrap'
import * as defaultConst from '../constants/default_constants'
import * as linkConst from '../constants/link_constants'
import UserInfo from './userinfo'

const AppMenu = ({ store }) => {
  const LINKS_GROUP = '_links_'
  const OTHERS_GROUP = '_others_'
  const reps = store.availableReports.sort((a, b) => a.name.localeCompare(b.name))
  const reportsGroupByEntity = reps.reduce((a, v) => {
    const link = (v.link && v.link.length > 0 ? LINKS_GROUP : false)
    const key = (link || v.entity_filter || OTHERS_GROUP);
    (a[key] = a[key] || []).push(v)
    return a
  }, {})

  const generateReportsByEntityGroup = key => (
    reportsGroupByEntity[key]
      .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
      .map((i, idx) => (
        <MenuItem key={idx} eventKey={i} className='dropdown-menu-right' onSelect={(opt) => {
          if (opt.link) {
          // redir to external
            window.open(opt.link, '_blank')
          } else {
            store.router.goTo(store.views.report, { id: opt.id }, store)
          }
        }} >
          {i.link && <span className='glyphicon glyphicon-link' />}
          {i.name}
        </MenuItem>
      ))
  )

  const reportsDDown = store.hasRight(linkConst.LINK_SHOW_REPORTS) && reps.length > 0 ? (
    <NavDropdown eventKey={4} title={store.__(linkConst.MENU_TITLE_REPORTING)} id='nav-dropdown4'>
      { Object.keys(reportsGroupByEntity).filter(r => r !== OTHERS_GROUP).map((key, index) => {
        const title = linkConst.LINKS_LIST[key]
          ? store.__(linkConst.LINKS_LIST[key])
          : (key === LINKS_GROUP ? store.__('Links') : store.__('Others'))
        return (<NavDropdown key={index} title={title} id='nav-dropdown2' className='dropdown-submenu'>
          { generateReportsByEntityGroup(key) }
        </NavDropdown>)
      })
      }
      { Object.keys(reportsGroupByEntity)
        .filter(r => r === OTHERS_GROUP)
        .map(key => generateReportsByEntityGroup(key))
      }
    </NavDropdown>
  ) : null

  function goTo (entityname) {
    store.router.goTo(store.views.entity_list, {
      entityname: entityname
    }, store, { _page: 1 })
  }

  function menuReports (entities) {
    const reports = store.reportsForEntitities(entities)
    return reports.length === 0 ? null : (
      <NavDropdown title={store.__('Reports')} id='nav-dropdown2'>
        {
          reports
            .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
            .map((i, idx) => {
              return (
                <MenuItem key={`rep_${idx}`} onClick={() => {
                  store.router.goTo(store.views.report, { id: i.id }, store)
                }}>
                  {i.name}
                </MenuItem>
              )
            })
        }
      </NavDropdown>
    )
  }

  function isActive (entityname) {
    return store.router.params ? store.router.params.entityname === entityname : false
  }

  function reloadPage () {
    window.location.reload()
  }

  function groupHasRights (rGroup) {
    return rGroup.filter(r => store.hasRight(r)).length > 0
  }

  const menuItems = {
    content: [linkConst.LINK_PERSONS, linkConst.LINK_FILMS, linkConst.LINK_YOUTUBE_ASSETS],
    contracts: [linkConst.LINK_CLIENTS, linkConst.LINK_CONTRACTS, linkConst.LINK_FINANCIAL_REPORTS, linkConst.LINK_XRATES,
      linkConst.LINK_CONTRACT_TIME_RESTRICTIONS, linkConst.LINK_ETL_RUNNER],
    flyprivate: [linkConst.LINK_PRICING, linkConst.LINK_SETTINGS, linkConst.LINK_CATEGORIES, linkConst.LINK_FPVTESTING, linkConst.LINK_VATRATES,
      linkConst.LINK_TIERS_SETTINGS, linkConst.LINK_CATEG_SETTINGS, linkConst.LINK_PPROLLS_LIST, linkConst.LINK_PPROLLS_SETUP, linkConst.LINK_PPROLLS_UPLOAD],
    settings: [linkConst.LINK_ENUMS, linkConst.LINK_RATING, linkConst.LINK_REPORTS, linkConst.LINK_RIGHTS, linkConst.LINK_ARCHIVE, linkConst.LINK_FILMCARGO_HELP]
  }

  const pagePerPage = {
    _page: 1,
    _perPage: localStorage.getItem('cargo_perPage') || Conf.perPage || 50
  }

  const menuTree = (<Nav>
    { groupHasRights(menuItems.content) && // --- CONTENT ---
      (<NavDropdown eventKey={2} title={store.__(linkConst.MENU_TITLE_CONTENT)} id='nav-dropdown2'>
        {
          store.hasRight(linkConst.LINK_FILMS) &&
          (<MenuItem eventKey={2.1} active={isActive(linkConst.LINK_FILMS)} onClick={() => store.router.goTo(store.views.entity_list, {
            entityname: linkConst.LINK_FILMS
          }, store, {
            ...pagePerPage, ...linkConst.DEFAULT_SORT[linkConst.LINK_FILMS]
          })}>
            {store.__(linkConst.LINK_FILMS_TITLE)}
          </MenuItem>)
        }
        {
          store.hasRight(linkConst.LINK_PERSONS) &&
          (<MenuItem eventKey={2.2} active={isActive(linkConst.LINK_PERSONS)} onClick={() => store.router.goTo(store.views.entity_list, {
            entityname: linkConst.LINK_PERSONS
          }, store, {
            ...pagePerPage, ...linkConst.DEFAULT_SORT[linkConst.LINK_PERSONS]
          })}>
            {store.__(linkConst.LINK_PERSONS_TITLE)}
          </MenuItem>)
        }

        {store.hasRight(linkConst.LINK_FILMS) && <MenuItem divider />}
        {
          store.hasRight(linkConst.LINK_YOUTUBE_ASSETS) &&
          (<MenuItem eventKey={2.4} active={isActive(linkConst.LINK_YOUTUBE_ASSETS)} onClick={() => store.router.goTo(store.views.entity_list, {
            entityname: linkConst.LINK_YOUTUBE_ASSETS
          }, store, {
            ...pagePerPage, ...linkConst.DEFAULT_SORT[linkConst.LINK_YOUTUBE_ASSETS]
          })}>
            {store.__(linkConst.LINK_YOUTUBE_ASSETS_TITLE)}
          </MenuItem>)
        }
        {
          store.hasRight(linkConst.LINK_FILMS) &&
          (<MenuItem eventKey={2.3} active={isActive(linkConst.LINK_UPLOADS)} onClick={() => store.router.goTo(store.views.uploads, {}, store, {})}>
            {store.__(linkConst.LINK_UPLOADS_TITLE)}
          </MenuItem>)
        }

        <MenuItem divider />
        { menuReports(menuItems.content) }
      </NavDropdown>)
    }

    { groupHasRights(menuItems.contracts) && // --- CONTRACTS ---
      (<NavDropdown eventKey={1} title={store.__(linkConst.MENU_TITLE_MANAGEMENT)} id='nav-dropdown1'>
        {
          store.hasRight(linkConst.LINK_CLIENTS) &&
          (<MenuItem eventKey={1.2} active={isActive(linkConst.LINK_CLIENTS)} onClick={() => store.router.goTo(store.views.entity_list, {
            entityname: linkConst.LINK_CLIENTS
          }, store, {
            ...pagePerPage, ...linkConst.DEFAULT_SORT[linkConst.LINK_CLIENTS]
          })}>
            {store.__(linkConst.LINK_CLIENTS_TITLE)}
          </MenuItem>)
        }
        {
          store.hasRight(linkConst.LINK_CONTRACTS) &&
          (<MenuItem eventKey={1.1} active={isActive(linkConst.LINK_CONTRACTS)} onClick={() => store.router.goTo(store.views.entity_list, {
            entityname: linkConst.LINK_CONTRACTS
          }, store, {
            ...pagePerPage, ...linkConst.DEFAULT_SORT[linkConst.LINK_CONTRACTS]
          })}>
            {store.__(linkConst.LINK_CONTRACTS_TITLE)}
          </MenuItem>)
        }
        {
          store.hasRight(linkConst.LINK_FINANCIAL_REPORTS) &&
          (<MenuItem eventKey={2.3} active={isActive(linkConst.LINK_FINANCIAL_REPORTS)} onClick={() => store.router.goTo(store.views.entity_list, {
            entityname: linkConst.LINK_FINANCIAL_REPORTS
          }, store, {
            ...pagePerPage, ...linkConst.DEFAULT_SORT[linkConst.LINK_FINANCIAL_REPORTS]

          })}>
            {store.__(linkConst.LINK_FINANCIAL_REPORTS_TITLE)}
          </MenuItem>)
        }
        {
          store.hasRight(linkConst.LINK_XRATES) &&
          (<MenuItem eventKey={2.4} active={isActive(linkConst.LINK_XRATES)} onClick={() => store.router.goTo(store.views.entity_list, {
            entityname: linkConst.LINK_XRATES
          }, store, {
            ...pagePerPage, ...linkConst.DEFAULT_SORT[linkConst.LINK_XRATES]

          })}>{store.__(linkConst.LINK_XRATES_TITLE)}
          </MenuItem>)
        }
        {
          store.hasRight(linkConst.LINK_CONTRACT_TIME_RESTRICTIONS) &&
          (<MenuItem eventKey={2.4} active={isActive(linkConst.LINK_CONTRACT_TIME_RESTRICTIONS)} onClick={() => store.router.goTo(store.views.entity_list, {
            entityname: linkConst.LINK_CONTRACT_TIME_RESTRICTIONS
          }, store, {
            ...pagePerPage, ...linkConst.DEFAULT_SORT[linkConst.LINK_CONTRACT_TIME_RESTRICTIONS]

          })}>{store.__(linkConst.LINK_CONTRACT_TIME_RESTRICTIONS_TITLE)}
          </MenuItem>)
        }
        {store.hasRight(linkConst.LINK_ETL_RUNNER) && <MenuItem divider />}
        {
          store.hasRight(linkConst.LINK_ETL_RUNNER) &&
          (<MenuItem eventKey={2.5} active={isActive(linkConst.LINK_ETL_RUNNER)}
            onClick={() => store.router.goTo(store.views[linkConst.LINK_ETL_RUNNER], {}, store, {})}>
            {store.__(linkConst.LINK_ETL_RUNNER_ROYALTIES_TITLE)}
          </MenuItem>)
        }
        <MenuItem divider />
        { menuReports(menuItems.contracts) }
      </NavDropdown>)
    }

    { groupHasRights(menuItems.flyprivate) && // --- FLYPRIVATE ---
      (<NavDropdown eventKey={3} title={store.__(linkConst.MENU_TITLE_PLATFORMS)} id='nav-dropdown3'>
        {
          store.hasRight(linkConst.LINK_PRICING) &&
          (<MenuItem eventKey={3.1} active={isActive(linkConst.LINK_PRICING)} onClick={() => store.router.goTo(store.views.entity_list, {
            entityname: linkConst.LINK_PRICING
          }, store, {
            ...pagePerPage, ...linkConst.DEFAULT_SORT[linkConst.LINK_PRICING]
          })}>{store.__(linkConst.LINK_PRICING_TITLE)}
          </MenuItem>)
        }
        {
          store.hasRight(linkConst.LINK_CATEGORIES) &&
          (<MenuItem eventKey={3.4} active={isActive(linkConst.LINK_CATEGORIES)} onClick={() => store.router.goTo(store.views.entity_list, {
            entityname: linkConst.LINK_CATEGORIES
          }, store, {
            ...pagePerPage, ...linkConst.DEFAULT_SORT[linkConst.LINK_CATEGORIES]
          })}>{store.__(linkConst.LINK_CATEGORIES_TITLE)}
          </MenuItem>)
        }
        {
          store.hasRight(linkConst.LINK_SETTINGS) &&
          (<MenuItem eventKey={3.3} active={isActive(linkConst.LINK_SETTINGS)} onClick={() => store.router.goTo(store.views.entity_list, {
            entityname: linkConst.LINK_SETTINGS
          }, store, {
            ...pagePerPage, ...linkConst.DEFAULT_SORT[linkConst.LINK_SETTINGS]
          })}>{store.__(linkConst.LINK_SETTINGS_TITLE)}
          </MenuItem>)
        }

        {(store.hasRight(linkConst.LINK_TIERS_SETTINGS) || store.hasRight(linkConst.LINK_CATEG_SETTINGS)) && <MenuItem divider />}
        {
          store.hasRight(linkConst.LINK_TIERS_SETTINGS) &&
          (<MenuItem eventKey={3.2} active={isActive(linkConst.LINK_TIERS_SETTINGS)} onClick={() => store.router.goTo(store.views.entity_list,
            { entityname: linkConst.LINK_TIERS_SETTINGS },
            store, { ...pagePerPage, ...linkConst.DEFAULT_SORT[linkConst.LINK_TIERS_SETTINGS] })}
          >
            {store.__(linkConst.LINK_TIERS_SETTINGS_TITLE)}
          </MenuItem>)
        }
        {
          store.hasRight(linkConst.LINK_CATEG_SETTINGS) &&
          (<MenuItem eventKey={3.5} active={isActive(linkConst.LINK_CATEG_SETTINGS)} onClick={() => store.router.goTo(store.views.entity_list,
            { entityname: linkConst.LINK_CATEG_SETTINGS },
            store, { ...pagePerPage, ...linkConst.DEFAULT_SORT[linkConst.LINK_CATEG_SETTINGS] })}
          >
            {store.__(linkConst.LINK_CATEG_SETTINGS_TITLE)}
          </MenuItem>)
        }

        {(store.hasRight(linkConst.LINK_PPROLLS_LIST) || store.hasRight(linkConst.LINK_PPROLLS_SETUP) || store.hasRight(linkConst.LINK_PPROLLS_UPLOAD)) && <MenuItem divider />}
        {
          store.hasRight(linkConst.LINK_PPROLLS_SETUP) &&
          (<MenuItem eventKey={3.2} active={isActive(linkConst.LINK_PPROLLS_SETUP)} onClick={() => store.router.goTo(store.views.entity_list,
            { entityname: linkConst.LINK_PPROLLS_SETUP },
            store, { ...pagePerPage, ...linkConst.DEFAULT_SORT[linkConst.LINK_PPROLLS_SETUP] })}
          >
            {store.__(linkConst.LINK_PPROLLS_SETUP_TITLE)}
          </MenuItem>)
        }
        {
          store.hasRight(linkConst.LINK_PPROLLS_UPLOAD) &&
          (<MenuItem eventKey={3.2} active={isActive(linkConst.LINK_PPROLLS_UPLOAD)} onClick={() => store.router.goTo(store.views.entity_list,
            { entityname: linkConst.LINK_PPROLLS_UPLOAD },
            store, { ...pagePerPage, ...linkConst.DEFAULT_SORT[linkConst.LINK_PPROLLS_UPLOAD] })}
          >
            {store.__(linkConst.LINK_PPROLLS_UPLOAD_TITLE)}
          </MenuItem>)
        }
        {
          store.hasRight(linkConst.LINK_PPROLLS_LIST) &&
          (<MenuItem eventKey={3.2} active={isActive(linkConst.LINK_PPROLLS_LIST)}
            onClick={() => store.router.goTo(store.views.report, { id: defaultConst.PPROLLS_REPORT_ID }, store)}
          >
            {store.__(linkConst.LINK_PPROLLS_LIST_TITLE)}
          </MenuItem>)
        }

        {(store.hasRight(linkConst.LINK_FPVTESTING) || store.hasRight(linkConst.LINK_VATRATES)) && <MenuItem divider />}
        {
          store.hasRight(linkConst.LINK_FPVTESTING) &&
          (<MenuItem eventKey={3.6} active={isActive(linkConst.LINK_FPVTESTING)} onClick={() => store.router.goTo(store.views.entity_list, {
            entityname: linkConst.LINK_FPVTESTING
          }, store, {
            ...pagePerPage, ...linkConst.DEFAULT_SORT[linkConst.LINK_FPVTESTING]
          })}>{store.__(linkConst.LINK_FPVTESTING_TITLE)}
          </MenuItem>)
        }
        {
          store.hasRight(linkConst.LINK_VATRATES) &&
          (<MenuItem eventKey={3.7} active={isActive(linkConst.LINK_VATRATES)} onClick={() => store.router.goTo(store.views.entity_list, {
            entityname: linkConst.LINK_VATRATES
          }, store, {
            ...pagePerPage, ...linkConst.DEFAULT_SORT[linkConst.LINK_VATRATES]
          })}>{store.__(linkConst.LINK_VATRATES_TITLE)}
          </MenuItem>)
        }
        <MenuItem divider />
        { menuReports(menuItems.flyprivate) }
      </NavDropdown>)
    }
    { reportsDDown /* --- REPORTS --- */ }

    { groupHasRights(menuItems.settings) && // --- SETTINGS ---
      (<NavDropdown eventKey={8} title={store.__(linkConst.MENU_TITLE_SETTINGS)} id='nav-dropdown8'>
        {
          store.hasRight(linkConst.LINK_ENUMS) &&
          (<MenuItem eventKey={8.1} active={isActive(linkConst.LINK_ENUMS)} onClick={() => store.router.goTo(store.views.enum_edit, {}, store, {})}>
            {store.__(linkConst.LINK_ENUMS_TITLE)}
          </MenuItem>)
        }
        {
          store.hasRight(linkConst.LINK_RATING) &&
          (<MenuItem eventKey={8.2} active={isActive(linkConst.LINK_RATING)} onClick={() => store.router.goTo(store.views.entity_list, {
            entityname: linkConst.LINK_RATING
          }, store, {
            ...pagePerPage, ...linkConst.DEFAULT_SORT[linkConst.LINK_RATING]
          })}>
            {store.__(linkConst.LINK_RATING_TITLE)}
          </MenuItem>)
        }
        {
          store.hasRight(linkConst.LINK_REPORTS) &&
          (<MenuItem eventKey={8.3} active={isActive(linkConst.LINK_REPORTS)} onClick={() => store.router.goTo(store.views.entity_list, {
            entityname: linkConst.LINK_REPORTS
          }, store, {
            ...pagePerPage, ...linkConst.DEFAULT_SORT[linkConst.LINK_REPORTS]
          })}>
            {store.__(linkConst.LINK_REPORTS_TITLE)}
          </MenuItem>)
        }
        {
          store.hasRight(linkConst.LINK_RIGHTS) &&
          (<MenuItem eventKey={8.4} active={isActive(linkConst.LINK_RIGHTS)} onClick={() => goTo(linkConst.LINK_RIGHTS)}>
            {store.__('rights')}
          </MenuItem>)
        }
        {
          store.hasRight(linkConst.LINK_ARCHIVE) &&
          (<MenuItem eventKey={8.5} active={isActive(linkConst.LINK_ARCHIVE)} onClick={() => goTo(linkConst.LINK_ARCHIVE)}>
            {store.__('archive')}
          </MenuItem>)
        }
        {
          store.hasRight(linkConst.LINK_FILMCARGO_HELP) &&
          (<MenuItem eventKey={8.6} active={isActive(linkConst.LINK_FILMCARGO_HELP)} onClick={() => store.router.goTo(store.views.entity_list, {
            entityname: linkConst.LINK_FILMCARGO_HELP
          }, store, {
            ...pagePerPage, ...linkConst.DEFAULT_SORT[linkConst.LINK_FILMCARGO_HELP]
          })}>
            {store.__(linkConst.LINK_FILMCARGO_HELP_TITLE)}
          </MenuItem>)
        }
      </NavDropdown>)
    }
  </Nav>)

  const inverse = ['dark-slate', 'simplex-snow', 'united'].indexOf(store.userCss) === -1
  const showHostname = ['loca', 'dev.', 'stg.'].indexOf((window.location.hostname).substring(0, 4)) >= 0
  const timeStamp = Math.round(+new Date() / 1000)
  const latestVersion = localStorage.getItem('latest_version') ? localStorage.getItem('latest_version').split('\xa0') : ''

  return (
    <Navbar fixedTop fluid collapseOnSelect inverse={inverse}>
      <Navbar.Header>
        <Navbar.Brand className='cursor-pointer'>
          <a href={'/?ts' + timeStamp} onClick={reloadPage}>
            {showHostname &&
              <span className='location-hostname rotator'>{(window.location.hostname).substring(0, 3)}</span>}
            {Conf.siteName}
            {store.loggedUser
              ? <span className='location-hostname app-version rotator'>{latestVersion && latestVersion[0]}</span>
              : ''}
          </a>
          { store.loggedUser && store.router.params && store.router.currentView && store.router.currentView.path !== '/update' && store.newVersion ? <a href="/update">
            <span className='label label-success'>{store.__('Get new version!')}</span>
          </a> : null }
        </Navbar.Brand>
        <Navbar.Toggle />
      </Navbar.Header>
      <Navbar.Collapse>
        { store.loggedUser && menuTree }
        <UserInfo store={store} />
      </Navbar.Collapse>
    </Navbar>
  )
}

export default observer(AppMenu)
